<script>
    import button from './ib-button.vue'

    /**
     * DEPRECATED: Use `ib-button-link`.
     */
    export default {
        name: 'ib-button-route',
        mixins: [button],

        props: {
            /**
            * The name of the target route
            */
            name: String,
            /**
            * The path of the target route
            */
            path: String,
            /**
            * Any parameters that should be passed to the route
            */
            params: Object
        },

        methods: {
            _click(e) {
                this.$router.push({
                    name: this.name,
                    path: this.path,
                    params: this.params
                });
            }
        }
    }
</script>

<docs>
    ```jsx
        <div>
            <p>Functionality only - this wraps a button and navigates to a specific route in vue-router. Don't actually click these, they don't do anything here.</p>
            <ib-button-route name="Button" path="ibbutton">Go to Buttons</ib-button-route>
            <ib-button-route name="Button" path="ibbutton">Go to Buttons</ib-button-route>

        </div>
    ```
</docs>
